import cn from 'classnames';
import { cloneElement } from 'react';
import { Tooltip } from '../../tooltip/Tooltip.tsx';
import { Link } from '../Link.tsx';
import styles from './IconLink.module.css';

type Props = React.ComponentPropsWithoutRef<typeof Link> & {
  /** Width of the SVG */
  width?: number | string;
  /** Height of the SVG */
  height?: number | string;
  /** Optional additional class names to apply to the link element */
  className?: string;
  /** Accessible name for screen readers */
  title: string;
  /** Reactified svg component */
  children: React.ReactElement<React.ComponentProps<'svg'> & { title?: string }>;
};

/**
 * {@link IconLink} can be used to create a link out of an svg icon, along with an accessible title
 * which is not displayed on the screen.  The resulting link is styled the same as our IconButton.
 */
export function IconLink({ width = 16, height = 16, className, title, children, ...linkProps }: Props) {
  const svgChild = cloneElement(children, { width, height, 'aria-hidden': true });

  return (
    <Tooltip
      content={title}
      placement="right"
      className={cn('btn icon-btn pad-8 width-fit-content', className)}
      render={<Link {...linkProps} />}
    >
      {svgChild}
      <span className={cn('visually-hidden', styles.IconLink_visuallyHiddenText)}>{title}</span>
    </Tooltip>
  );
}
